import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';

var _excluded = ["isFocusable", "isFocused", "onKeyDown", "onFocus", "children"];
var AdvancedTableColumnHeaders = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isFocusable = _ref.isFocusable,
    isFocused = _ref.isFocused,
    onKeyDown = _ref.onKeyDown,
    onFocus = _ref.onFocus,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    role: "row",
    tabIndex: isFocusable ? isFocused ? 0 : -1 : undefined,
    onKeyDown: isFocusable ? onKeyDown : undefined,
    onFocus: isFocusable ? onFocus : undefined,
    className: styles.advancedTableColumnHeaders,
    ref: ref
  }), children);
});

export { AdvancedTableColumnHeaders as default };
